import { types } from 'mobx-state-tree';
import FilterOptionModel from './FilterOptionModel';

const GroupedOptionModel = types
    .model('GroupedOption', {
        parentOption: FilterOptionModel,
        childOptions: types.array(FilterOptionModel),
    })
    .views(self => ({
        hasAnySelectedChildOption(options) {
            return self.childOptions
                .map(child => child.value)
                .some(child => options.map(opt => opt.value).includes(child));
        },
    }));

export default GroupedOptionModel;



// WEBPACK FOOTER //
// ./src/js/apps/find-designers/models/GroupedOptionModel.js